import { render } from "./rdsSummary.vue?vue&type=template&id=b045bf9a"
import script from "./rdsSummary.vue?vue&type=script&lang=js"
export * from "./rdsSummary.vue?vue&type=script&lang=js"

import "./rdsSummary.vue?vue&type=style&index=0&id=b045bf9a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__